import { createSelector } from "reselect";

export const initialScrapeTasksSelector = createSelector(
    state => state.scheduler.entries,
    state => state
);

export const selectedInitialScrapeTasksSelector = createSelector(
    state => state.scheduler.entries.selectedInitialScrapeTasks,
    state => state
);

export const startTasksDialogSelector = createSelector(
    state => state.scheduler.entries.startTasksDialog,
    state => state
);

export const editMetadataDialogSelector = createSelector(
    state => state.scheduler.entries.editMetadataDialog,
    state => state
);

export const intervalHoursTasksDialogSelector = createSelector(
    state => state.scheduler.entries.intervalHoursTasksDialog,
    state => state
);

export const intervalHoursAllTasksDialogSelector = createSelector(
    state => state.scheduler.entries.intervalHoursAllTasksDialog,
    state => state
);

export const paginationLimitTasksDialogSelector = createSelector(
    state => state.scheduler.entries.paginationLimitTasksDialog,
    state => state
);

export const paginationLimitAllTasksDialogSelector = createSelector(
    state => state.scheduler.entries.paginationLimitAllTasksDialog,
    state => state
);

export const tasksDialogSelector = createSelector(
    state => state.scheduler.entries.tasksDialog,
    state => state
);

export const oneTimeSearchDialogSelector = createSelector(
    state => state.scheduler.entries.oneTimeSearchDialog,
    state => state
);

export const rescheduleDialogSelector = createSelector(
    state => state.scheduler.entries.rescheduleDialog,
    state => state
);

export const progressDialogSelector = createSelector(
    state => state.scheduler.entries.progressDialog,
    state => state
);

export const deleteDialogSelector = createSelector(
    state => state.scheduler.entries.deleteDialog,
    state => state
);

export const downloadDialogSelector = createSelector(
    state => state.scheduler.entries.downloadDialog,
    state => state
);

export const scheduleDialogSelector = createSelector(
    state => state.scheduler.entries.scheduleDialog,
    state => state
);
